<template>
  <div class="min-h-screen bg-gradient-to-b from-psychology-calm to-psychology-warm">
    <!-- 顶部导航 -->
    <div class="bg-white/80 backdrop-blur-sm border-b border-gray-200 sticky top-0 z-40">
      <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-psychology-primary rounded-xl flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6 text-white">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
            </div>
            <div>
              <h1 class="text-2xl font-bold">测评历史</h1>
              <p class="text-sm text-gray-600">查看和管理您的评估记录</p>
            </div>
          </div>
          <router-link to="/" class="btn-secondary flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
              <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path>
              <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            </svg>
            返回首页
          </router-link>
        </div>
      </div>
    </div>

    <!-- 主要内容 -->
    <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div class="space-y-8">
        <!-- 统计卡片 -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <!-- 总测评次数 -->
          <div class="card">
            <div class="p-6">
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm text-gray-600">总测评次数</p>
                  <p class="text-2xl font-bold text-psychology-primary">{{ totalCount }}</p>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8 text-psychology-primary/60">
                  <path d="M8 2v4"></path>
                  <path d="M16 2v4"></path>
                  <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                  <path d="M3 10h18"></path>
                </svg>
              </div>
            </div>
          </div>

          <!-- 完成测评 -->
          <div class="card">
            <div class="p-6">
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm text-gray-600">完成测评</p>
                  <p class="text-2xl font-bold text-psychology-success">{{ completedCount }}</p>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8 text-psychology-success/60">
                  <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                  <path d="M18 17V9"></path>
                  <path d="M13 17V5"></path>
                  <path d="M8 17v-3"></path>
                </svg>
              </div>
            </div>
          </div>

          <!-- 平均RPI指数 -->
          <div class="card">
            <div class="p-6">
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm text-gray-600">平均RPI指数</p>
                  <p class="text-2xl font-bold text-psychology-accent">{{ averageRPI }}</p>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8 text-psychology-accent/60">
                  <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                  <polyline points="16 7 22 7 22 13"></polyline>
                </svg>
              </div>
            </div>
          </div>

          <!-- 测评类型 -->
          <div class="card">
            <div class="p-6">
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm text-gray-600">测评类型</p>
                  <p class="text-sm">
                    <span class="text-psychology-primary font-semibold">{{ selfCount }}</span> 自测 /
                    <span class="text-psychology-secondary font-semibold">{{ partnerCount }}</span> 恋人测
                  </p>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8 text-gray-400">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
            </div>
          </div>
        </div>

        <!-- 数据管理 -->
        <div class="card">
          <div class="p-6">
            <div class="text-2xl font-semibold flex items-center gap-2 mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" x2="12" y1="15" y2="3"></line>
              </svg>
              数据管理
            </div>
            <div class="flex flex-wrap gap-3">
              <button @click="exportJSON" class="btn-secondary flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7 10 12 15 17 10"></polyline>
                  <line x1="12" x2="12" y1="15" y2="3"></line>
                </svg>
                导出JSON
              </button>
              <button @click="exportCSV" class="btn-secondary flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7 10 12 15 17 10"></polyline>
                  <line x1="12" x2="12" y1="15" y2="3"></line>
                </svg>
                导出CSV
              </button>
              <button @click="confirmClearAll" class="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md transition-colors flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                  <path d="M3 6h18"></path>
                  <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                  <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                  <line x1="10" x2="10" y1="11" y2="17"></line>
                  <line x1="14" x2="14" y1="11" y2="17"></line>
                </svg>
                清除所有记录
              </button>
            </div>
          </div>
        </div>

        <!-- 测评记录列表 -->
        <div class="space-y-4">
          <h2 class="text-xl font-semibold flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
              <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
              <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
              <path d="M10 9H8"></path>
              <path d="M16 13H8"></path>
              <path d="M16 17H8"></path>
            </svg>
            测评记录
          </h2>

          <!-- 空状态 -->
          <div v-if="records.length === 0" class="card p-12 text-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-16 h-16 mx-auto mb-4 text-gray-300">
              <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
              <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
            </svg>
            <h3 class="text-xl font-semibold text-gray-600 mb-2">暂无测评记录</h3>
            <p class="text-gray-500 mb-6">开始您的第一次测评，了解自己的恋爱占有欲指数</p>
            <button @click="handleStartAssessment('self')" class="btn-primary inline-flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
              </svg>
              开始测评
            </button>
          </div>

          <!-- 记录卡片 -->
          <div 
            v-for="record in records" 
            :key="record.id"
            class="card hover:shadow-lg transition-shadow"
          >
            <div class="p-6">
              <div class="grid grid-cols-1 lg:grid-cols-4 gap-4">
                <!-- 基本信息 -->
                <div class="lg:col-span-2">
                  <div class="flex items-start justify-between mb-4">
                    <div>
                      <div class="flex items-center gap-2 mb-2">
                        <span class="px-2.5 py-0.5 text-xs font-semibold rounded-full bg-psychology-primary text-white">
                          {{ record.assessmentType === 'self' ? '给自己测' : '为恋人测' }}
                        </span>
                        <span class="px-2.5 py-0.5 text-xs font-semibold rounded-full text-green-600 border border-green-600">
                          已完成
                        </span>
                      </div>
                      <p class="text-sm text-gray-600">{{ formatDate(record.timestamp) }}</p>
                      <p class="text-xs text-gray-500 mt-1">用时：{{ record.duration || '未知' }}</p>
                    </div>
                  </div>
                  <div class="text-sm text-gray-600 space-y-1">
                    <p>年龄：{{ getAgeLabel(record.basicInfo?.age) }}</p>
                    <p>性别：{{ getGenderLabel(record.basicInfo?.gender) }}</p>
                    <p>关系状态：{{ getRelationshipStatusLabel(record.basicInfo?.relationshipStatus) }}</p>
                  </div>
                </div>

                <!-- RPI指数 -->
                <div class="lg:col-span-1">
                  <div class="text-center">
                    <div class="mb-3">
                      <div class="text-3xl font-bold text-psychology-primary mb-1">
                        {{ Math.round(record.rpiScore) }}
                      </div>
                      <div class="text-xs text-gray-600">RPI 指数</div>
                    </div>
                    <div class="px-2.5 py-0.5 text-xs font-semibold rounded-full inline-block"
                         :class="getLevelClass(record.rpiScore)">
                      {{ getLevelText(record) }}
                    </div>
                    <div class="mt-3">
                      <div class="relative w-full overflow-hidden rounded-full bg-gray-200 h-2">
                        <div class="h-full bg-psychology-primary transition-all" 
                             :style="{ width: record.rpiScore + '%' }">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 操作按钮 -->
                <div class="lg:col-span-1">
                  <div class="flex flex-col gap-2">
                    <button 
                      @click="viewResult(record)" 
                      class="btn-primary flex items-center justify-center gap-2 text-sm"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                        <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                      查看结果
                    </button>
                    <button 
                      @click="confirmDelete(record.id)" 
                      class="hover:bg-red-50 text-red-600 px-3 py-2 rounded-md transition-colors flex items-center justify-center gap-2 text-sm border border-transparent hover:border-red-200"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                        <path d="M3 6h18"></path>
                        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                        <line x1="10" x2="10" y1="11" y2="17"></line>
                        <line x1="14" x2="14" y1="11" y2="17"></line>
                      </svg>
                      删除
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 回到顶部 -->
    <BackToTop />

    <!-- 删除确认对话框 -->
    <ConfirmDialog
      v-if="showDeleteDialog"
      title="确认删除"
      :message="deleteMessage"
      @confirm="handleDelete"
      @cancel="showDeleteDialog = false"
    />

    <!-- 激活码验证对话框 -->
    <ActivationCodeDialog 
      :show="showActivationDialog"
      :target-route="targetRoute"
      @close="handleActivationClose"
    />
  </div>
</template>

<script>
import BackToTop from '../components/BackToTop.vue'
import ConfirmDialog from '../components/ConfirmDialog.vue'
import ActivationCodeDialog from '../components/ActivationCodeDialog.vue'
import { useToast } from 'vue-toastification'
import { isActivated } from '../utils/activationUtils'

export default {
  name: 'HistoryPage',
  components: {
    BackToTop,
    ConfirmDialog,
    ActivationCodeDialog
  },
  setup() {
    const toast = useToast()
    return { toast }
  },
  data() {
    return {
      records: [],
      showDeleteDialog: false,
      deleteMessage: '',
      deleteTarget: null,
      showActivationDialog: false,
      targetRoute: '',
      // 选项映射
      ageOptions: [
        '18岁以下',
        '18-24岁',
        '25-29岁',
        '30-34岁',
        '35-39岁',
        '40岁以上'
      ],
      genderOptions: [
        '男性',
        '女性',
        '其他',
        '不愿透露'
      ],
      relationshipStatusOptions: [
        '单身（从未恋爱）',
        '单身（曾经恋爱过）',
        '热恋期',
        '稳定期',
        '平淡期',
        '冷战期',
        '已婚/订婚',
        '异地恋'
      ]
    }
  },
  computed: {
    totalCount() {
      return this.records.length
    },
    completedCount() {
      return this.records.length
    },
    averageRPI() {
      if (this.records.length === 0) return 0
      const sum = this.records.reduce((acc, record) => acc + record.rpiScore, 0)
      return Math.round(sum / this.records.length)
    },
    selfCount() {
      return this.records.filter(r => r.assessmentType === 'self').length
    },
    partnerCount() {
      return this.records.filter(r => r.assessmentType === 'partner').length
    }
  },
  mounted() {
    this.loadRecords()
  },
  methods: {
    // 激活码验证方法
    handleStartAssessment(type) {
      // 检查是否已激活
      if (isActivated()) {
        // 已激活，直接跳转
        this.$router.push(`/assessment/start?type=${type}`)
      } else {
        // 未激活，显示激活码对话框
        this.targetRoute = `/assessment/start?type=${type}`
        this.showActivationDialog = true
      }
    },
    
    handleActivationClose() {
      this.showActivationDialog = false
    },

    // 选项映射方法
    getAgeLabel(age) {
      if (age === null || age === undefined) return '未填写'
      return this.ageOptions[age] || '未填写'
    },
    getGenderLabel(gender) {
      if (gender === null || gender === undefined) return '未填写'
      // gender 存储的是 1-4，需要减1来对应数组索引
      return this.genderOptions[gender - 1] || '未填写'
    },
    getRelationshipStatusLabel(status) {
      if (status === null || status === undefined) return '未填写'
      // relationshipStatus 存储的是 1-8，需要减1来对应数组索引
      return this.relationshipStatusOptions[status - 1] || '未填写'
    },
    loadRecords() {
      try {
        const stored = localStorage.getItem('rpi_history')
        if (stored) {
          this.records = JSON.parse(stored)
          // 按时间倒序排序
          this.records.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
        }
      } catch (e) {
        console.error('加载历史记录失败:', e)
        this.toast.error('加载历史记录失败')
      }
    },
    formatDate(timestamp) {
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}年${month}月${day}日 ${hours}:${minutes}`
    },
    getLevelText(record) {
      // 优先使用 rpiLevel.level，其次使用 level，最后根据分数推断
      if (record.rpiLevel && record.rpiLevel.level) {
        return record.rpiLevel.level
      }
      if (record.level) {
        return record.level
      }
      // 根据分数推断等级
      const score = record.rpiScore
      if (score < 20) return '很低（自由自在）'
      if (score < 40) return '较低（轻松自在）'
      if (score < 60) return '中等（恰到好处）'
      if (score < 80) return '较高（深情投入）'
      return '很高（爱到极致）'
    },
    getLevelClass(score) {
      if (score < 20) return 'text-blue-600 border border-blue-600'
      if (score < 40) return 'text-green-600 border border-green-600'
      if (score < 60) return 'text-yellow-600 border border-yellow-600'
      if (score < 80) return 'text-orange-600 border border-orange-600'
      return 'text-red-600 border border-red-600'
    },
    viewResult(record) {
      // 将记录设置为当前结果
      localStorage.setItem('rpi_current_result', JSON.stringify(record))
      this.$router.push({
        path: '/assessment/result',
        query: { 
          type: record.assessmentType,
          from: 'history'
        }
      })
    },
    confirmDelete(recordId) {
      this.deleteTarget = recordId
      this.deleteMessage = '确定要删除这条测评记录吗？删除后无法恢复。'
      this.showDeleteDialog = true
    },
    handleDelete() {
      if (this.deleteTarget === 'all') {
        // 清除所有记录
        localStorage.removeItem('rpi_history')
        this.records = []
        this.toast.success('已清除所有记录')
      } else {
        // 删除单条记录
        this.records = this.records.filter(r => r.id !== this.deleteTarget)
        localStorage.setItem('rpi_history', JSON.stringify(this.records))
        this.toast.success('已删除记录')
      }
      this.showDeleteDialog = false
      this.deleteTarget = null
    },
    confirmClearAll() {
      if (this.records.length === 0) {
        this.toast.warning('没有可清除的记录')
        return
      }
      this.deleteTarget = 'all'
      this.deleteMessage = `确定要清除所有 ${this.records.length} 条测评记录吗？此操作无法恢复！`
      this.showDeleteDialog = true
    },
    exportJSON() {
      if (this.records.length === 0) {
        this.toast.warning('没有可导出的记录')
        return
      }
      try {
        const dataStr = JSON.stringify(this.records, null, 2)
        const blob = new Blob([dataStr], { type: 'application/json' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `RPI历史记录_${new Date().toISOString().split('T')[0]}.json`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
        this.toast.success('JSON导出成功！')
      } catch (e) {
        console.error('导出失败:', e)
        this.toast.error('导出失败，请稍后重试')
      }
    },
    exportCSV() {
      if (this.records.length === 0) {
        this.toast.warning('没有可导出的记录')
        return
      }
      try {
        // CSV表头
        const headers = ['日期', '测评类型', 'RPI指数', '等级', '年龄', '性别', '关系状态']
        const csvRows = [headers.join(',')]
        
        // 数据行
        this.records.forEach(record => {
          const row = [
            this.formatDate(record.timestamp),
            record.assessmentType === 'self' ? '给自己测' : '为恋人测',
            Math.round(record.rpiScore),
            this.getLevelText(record),
            this.getAgeLabel(record.basicInfo?.age),
            this.getGenderLabel(record.basicInfo?.gender),
            this.getRelationshipStatusLabel(record.basicInfo?.relationshipStatus)
          ]
          csvRows.push(row.join(','))
        })
        
        const csvStr = csvRows.join('\n')
        const BOM = '\uFEFF' // 添加BOM以支持中文
        const blob = new Blob([BOM + csvStr], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `RPI历史记录_${new Date().toISOString().split('T')[0]}.csv`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
        this.toast.success('CSV导出成功！')
      } catch (e) {
        console.error('导出失败:', e)
        this.toast.error('导出失败，请稍后重试')
      }
    }
  }
}
</script>

